/*
 * TabStrip control
*/

rs.module("controls/navigation/tabstrip",

    [
        "ui/framework/userstate-manager"
    ],

    function (userStateManager) {

        var _jsSelectors;
        var _cssClasses;

        var _tabSelector;
        var _contentTabbableElementsSelector;

        // Initialize
        function initialize(jsSelectors, cssClasses) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;

            _tabSelector = `[data-js~=${_jsSelectors._tabStrip}] [data-js=${_jsSelectors._tab}]`;
            _contentTabbableElementsSelector = `[data-js~=${_jsSelectors._tabStrip}] [data-js=${_jsSelectors._content}] :tabbable`;
            
            // We want to listen to all tab clicks that ever get clicked
            $(document).on("click", _tabSelector, _onTabClicked);

            // We want to listen for any key presses while a tab has focus
            $(document).on("keydown", _tabSelector, _onTabKeyPressed);            

            // We want to listen for any key presses while on a tabbable element with a tab's content
            $(document).on("keydown", _contentTabbableElementsSelector, _onContentTabbableElementKeyPressed);

            // One-time initialization only
            exports.initialize = function () { };
        }

        //
        // Exported function to allow selecting a tab via javascript
        //
        function setSelectedTab(tabKey) {
            var tabToSelect = $(`${_tabSelector}[data-tab=${tabKey}]`);
            _onTabClicked.call(tabToSelect);
        }

        //
        // Exported function to allow getting the tab text by the tab key
        //
        function getTabText(tabKey) {
            var tab = $(`${_tabSelector}[data-tab=${tabKey}]`);
            return tab.text();
        }

        //
        // Exported function to allow setting the tab text by the tab key
        //
        function setTabText(tabKey, text) {
            var tab = $(`${_tabSelector}[data-tab=${tabKey}]`);
            tab.text(text);
        }

        //
        // jQuery callback when a tab is clicked
        //
        function _onTabClicked() {
            var clickedTab = $(this);
            var tabStrip = _getTabStrip(clickedTab);

            // Get the currently selected tab
            var selectedTab = _getSelectedTab(tabStrip);

            // If the tab has changed...
            if (selectedTab != clickedTab) {

                // If there was a selected one unselect it
                if (selectedTab != null) {
                    _setTabState(selectedTab, false);
                }

                // If there is one selected now (has to be?), select it
                if (clickedTab != null) {
                    _setTabState(clickedTab, true);

                    // User may not have configured the tab control to persist state
                    if (tabStrip.data("userstatekey")) {
                        userStateManager.persist(tabStrip.data("userstatekey"), clickedTab.data("tab"));
                    }
                }
            }
        };

        //
        // jQuery callback when a key is pressed while focus is on a tab
        //
        function _onTabKeyPressed(e) {

            // only do anything if left or right arrow is pressed
            if (e.which == 37 || e.which == 39) {

                // determine which tab to move to based on which key was pressed
                var tabToMoveTo = e.which == 37 ? $(this).prev() : $(this).next();

                // if there is a tab to move to, select it
                if (tabToMoveTo.length > 0) {
                    _onTabClicked.call(tabToMoveTo);
                }
            }
        };

        //
        // jQuery callback when a key is pressed while focus is on a tabbable element within a tab's content
        //
        function _onContentTabbableElementKeyPressed(e) {

            var tabContent = $(this).closest(`[data-js=${_jsSelectors._content}]`);

            // if 'tab' key is pressed (and not while holding shift), and this is the last tabbable element in the current tab, we want to move to the next tab
            if (e.which == 9 && !e.shiftKey && $(this).is(tabContent.find(":tabbable").last())) {

                // When a modal is being opened, the body will have the class 'modal-open' applied to it
                // In this case, we don't want pressing tab to do anything because doing so could affect the display of the modal as it is opening
                // The exception to this is if the tabs are inside a modal, then proceed with our custom tabbing behavior
                if ($("body").hasClass("modal-open") && $(this).closest(".modal").length == 0) {
                    e.preventDefault()
                }
                else {
                    var nextTab = _getSelectedTab(_getTabStrip(tabContent)).next();

                    // if there is a tab to move to, select it
                    if (nextTab.length > 0) {

                        // must prevent the default behavior of pressing tab, which would move to the next tabbable element in the DOM and not our next tab
                        e.preventDefault();
                        _onTabClicked.call(nextTab);
                    }
                }
            }
        };

        //
        // Get the tab strip that contains the given tab
        //
        function _getTabStrip(tab) {
            return tab.closest(`[data-js~=${_jsSelectors._tabStrip}`);
        }

        //
        // Get the selected tab (if any) from the given tab strip
        //
        function _getSelectedTab(tabStrip) {
            return tabStrip.find(`.${_cssClasses._selected}[data-js=${_jsSelectors._tab}]`);
        }

        //
        // Get the content div for the given tab
        //
        function _getTabContent(tab) {
            var tabStrip = _getTabStrip(tab);

            return tabStrip.js(_jsSelectors._content, { multiple: true }).filter(`[data-tab=${tab.data("tab")}]`);
        }

        //
        // Set the selection state of the given tab
        //
        function _setTabState(tab, selected) {

            // add or remove tab from the tab order based on whether it is selected
            tab.attr("tabindex", selected ? "0" : null);

            // since we are moving tabs in and out of the tab order, we need to set focus manually
            if (selected) {
                tab.focus();
            }

            // Toggle selection of the tab
            tab.toggleClass(_cssClasses._selected, selected);

            // As well as the content
            _getTabContent(tab).toggleClass(_cssClasses._selected, selected);
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            setSelectedTab: setSelectedTab,
            getTabText: getTabText,
            setTabText: setTabText
        };

        return exports;
    }
);